import styled from 'styled-components'

export const AboutHeaderContainer = styled.div`
    background-image: linear-gradient(
  270deg,
  hsl(358deg 100% 30%) 0%,
  hsl(356deg 98% 27%) 11%,
  hsl(355deg 94% 25%) 22%,
  hsl(355deg 89% 22%) 33%,
  hsl(355deg 83% 20%) 44%,
  hsl(355deg 77% 17%) 56%,
  hsl(357deg 70% 14%) 67%,
  hsl(1deg 65% 11%) 78%,
  hsl(2deg 73% 8%) 89%,
  hsl(0deg 100% 4%) 100%
);
`

export const EuphaFamily = styled.div`
  text-transform: uppercase;
  font-weight: 700;
  font-size: 7em;
  text-align: center;
  padding-top: 56px;

  h1{
    line-height: 0.8em;
    background: #150000;
    background: linear-gradient(to right, #150000 0%, #990006 11%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  h1:nth-child(2){
    margin-left: 272px;

    @media (max-width: 550px) {
      /* Phones */
      margin-left: 50px;
    }

    @media (max-width: 1100px) {
        /* Tablets */
        margin-left: 50px;
    }
  }

  @media (max-width: 550px) {
      /* Phones */
      font-size: 3em;
    }

    @media (max-width: 1100px) {
        /* Tablets */
        font-size: 3em;
    }

`

export const WeAreEupha = styled.div`
  text-transform: uppercase;
  margin: 0 150px;
  padding: 50px 0px;
  margin-top: -170px;
  display: flex;
  flex-direction: column;
  text-align: left;


  p{ color: white }
  span{ color: rgba(234, 11, 42, 1) }

  p:nth-child(1){
    font-size: 2em;
    text-transform: none;

    @media (max-width: 550px) {
      /* Phones */
      margin: 0;
      font-size: 1.5em;
    }

    @media (max-width: 1100px) {
        /* Tablets */
        font-size: 1.5em;
    }
  }

  p:nth-child(2){
    font-weight: 500;
    font-size: 3.5em;
    margin-top: -10px;

    @media (max-width: 550px) {
      /* Phones */
      font-size: 1.5em;
    }

    @media (max-width: 1100px) {
        /* Tablets */
        font-size: 1.5em;
    }
  }

  @media (max-width: 550px) {
      /* Phones */
      margin: 0 25px;
      margin-top: 0;
    }

    @media (max-width: 1100px) {
        /* Tablets */
        margin: 0 25px;
        margin-top: -40px;
    }
`